import { createToastInterface } from 'vue-toastification';

const ToastService = new (class  {
  constructor() {
    this.pluginOptions = { timeout: 3000 };
    this.toast = createToastInterface(this.pluginOptions);
  }

  toastSuccess(text) {
    this.toast.success(text);
  }

  toastWarning(text) {
    this.toast.warning(text);
  }

  toastError(text) {
    this.toast.error(text);
  }

  toastErrorTimeout(text, timeout) {
    this.toast.error(text, {timeout: timeout});
  }
})();

export default ToastService;